import { useMemo } from 'react';
import { usePostApiDevSignCmsMutation } from '../app/athenaApiGen';
import { createDevSigner } from './devSigner';
import type { Signer } from './types';

export function useSigner(): Signer {
  const [trigger] = usePostApiDevSignCmsMutation();

  return useMemo<Signer>(
    () =>
      createDevSigner(async (req) =>
        trigger({ handlersDevSignCmsRequest: req }).unwrap(),
      ),
    [trigger],
  );
}
